'use client';

import React__default, { useMemo } from 'react';
import MultipleSelect from '../../MultipleSelect/index.js';
import { ELanguage } from '../../Utils/constants.js';
import { t } from '../../Utils/helpers.js';

var JobLevel = function (props) {
    var _a = props.isMobile, isMobile = _a === void 0 ? false : _a, _b = props.language, language = _b === void 0 ? ELanguage.EN : _b, _c = props.customTitle, customTitle = _c === void 0 ? '' : _c, setJobLevel = props.setJobLevel, jobLevelOptions = props.jobLevelOptions, jobLevel = props.jobLevel;
    var memoOptions = useMemo(function () {
        var optionList = [];
        if (jobLevelOptions !== undefined && (jobLevelOptions === null || jobLevelOptions === void 0 ? void 0 : jobLevelOptions.length) > 0) {
            jobLevelOptions.map(function (item, _) {
                var _a, _b, _c;
                // Required to parse toString because some time data is number
                if (item.id !== '-1' || item.id.toString() !== '-1') {
                    var itemId = (_b = (_a = item === null || item === void 0 ? void 0 : item.id) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '-1';
                    optionList.push({
                        id: parseInt(itemId),
                        name: (_c = item.text) !== null && _c !== void 0 ? _c : ''
                    });
                }
            });
        }
        return optionList;
    }, [jobLevelOptions]);
    var handleOnChangeValue = function (value) {
        setJobLevel && setJobLevel(value);
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("label", null, customTitle || t('Job level', language)),
        React__default.createElement("div", null,
            React__default.createElement(MultipleSelect, { key: "job-level-multiple-select-".concat(jobLevelOptions === null || jobLevelOptions === void 0 ? void 0 : jobLevelOptions.length), name: 'job-level', options: memoOptions, defaultSelect: jobLevel, onChange: function (e) { return handleOnChangeValue(e.value); }, selectPlaceholder: t('Please select ...', language), optionsStyle: { maxHeight: '220px' }, dropdownStyle: { width: '100%', boxShadow: 'none' }, isMobile: isMobile, langCode: language, sortEnable: true }))));
};

export { JobLevel as default };
//# sourceMappingURL=index.js.map
